// NgRx
import { createAction, props } from '@ngrx/store';

// DTOs
import { IUserProfileViewModel } from '@tech/api-clients/auth';

export enum UserTypes {
  initUserState = '[User] Init State',
  getCurrentUserDetailsLoad = '[User] Get Current User Details Load',
  getCurrentUserDetailsSuccess = '[User] Get Current User Details Success',
  getCurrentUserDetailsError = '[User] Get Current User Details Error',
  getCurrentUserRolesLoad = '[User] Get Current User Roles Load',
  getCurrentUserRolesSuccess = '[User] Get Current User Roles Success',
  getCurrentUserRolesError = '[User] Get Current User Roles Error',
  clearAllMessages = '[User] Clear All Messages',
}

export const initUserState = createAction(
  UserTypes.initUserState,
  props<{ moduleCode: string }>()
);

export const getCurrentUserDetailsLoad = createAction(
  UserTypes.getCurrentUserDetailsLoad
);

export const getCurrentUserDetailsSuccess = createAction(
  UserTypes.getCurrentUserDetailsSuccess,
  props<{ user: IUserProfileViewModel }>()
);

export const getCurrentUserDetailsError = createAction(
  UserTypes.getCurrentUserDetailsError,
  props<{ error: any }>()
);

export const getCurrentUserRolesLoad = createAction(
  UserTypes.getCurrentUserRolesLoad,
  props<{ moduleCode: string }>()
);

export const getCurrentUserRolesSuccess = createAction(
  UserTypes.getCurrentUserRolesSuccess,
  props<{ roles: string[] }>()
);

export const getCurrentUserRolesError = createAction(
  UserTypes.getCurrentUserRolesError,
  props<{ error: any }>()
);

export const userClearAllMessages = createAction(UserTypes.clearAllMessages);
